import { createSlice } from '@reduxjs/toolkit'
import { sortActiveLoyaltyTiers } from '@/lib/loyalty-benefits'
import { loyaltyApi } from '@/store/api/loyaltyApi'
import type { RootState } from '@/store/store'

interface LoyaltyState {
	lastFetchedAt: string | null
}

const initialState: LoyaltyState = {
	lastFetchedAt: null,
}

const loyaltySlice = createSlice({
	name: 'loyalty',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(loyaltyApi.endpoints.getLoyaltyTiers.matchFulfilled, (state) => {
			state.lastFetchedAt = new Date().toISOString()
		})
	},
})

const selectLoyaltyTiersQueryResult = (state: RootState) => loyaltyApi.endpoints.getLoyaltyTiers.select()(state)

export const selectLoyaltyTiers = (state: RootState) => sortActiveLoyaltyTiers(selectLoyaltyTiersQueryResult(state).data?.data ?? [])

export const selectLoyaltyTiersLoading = (state: RootState) => selectLoyaltyTiersQueryResult(state).isLoading

export const selectLoyaltyTiersError = (state: RootState) => selectLoyaltyTiersQueryResult(state).isError

export const selectLoyaltyLastFetchedAt = (state: RootState) => state.loyalty.lastFetchedAt

export default loyaltySlice.reducer
